import {
	useReactFlow as originalUseReactFlow,
	applyNodeChanges as originalApplyNodeChanges,
	applyEdgeChanges as originalApplyEdgeChanges,
} from 'reactflow';

import { EdgeData, NodeData } from './types';

export const useReactFlow = originalUseReactFlow<NodeData, EdgeData>;
export const applyNodeChanges = originalApplyNodeChanges<NodeData>;
export const applyEdgeChanges = originalApplyEdgeChanges<EdgeData>;
